import { atom, useAtom } from "jotai";

// モバイル警告を表示しないフラグ
const notShowMobileWarningAtom = atom<boolean>(false);

// カスタムフック
export const useNotShowMobileWarning = () => {
  return useAtom(notShowMobileWarningAtom);
};
